module.exports = __webpack_public_path__ + "static/media/eede34b2.jpg";